import React from "react";
import "../../css/my style.css";
import "../../css/my style3.css";
import "../../components/my script";
import Sidenav from "../../components/Sidenav/AISidenav";
import Navbar from "../../components/navbar";
import Footertutorials from "../../components/Footer-tutorials";
import SyntaxHighlighterComponent from "../../components/SyntaxHighlighterComponent";
import { Helmet } from "react-helmet";
import ButtonNext from "../../components/Buttonnext";
import ButtonPrevious from "../../components/Buttonprevious";
import ScrollToTopLink from "../../components/ScrollToTop";

export default function AIImageProcessing() {
  const newCode = {
    padding: '20px',
    textAlign: 'left',
    background: 'white',
    color: 'black'
  };

  const imageProcessingExample = `
# Example of Basic Image Processing with OpenCV in Python
import cv2

# Load an image
image = cv2.imread('example.jpg')

# Convert the image to grayscale
gray_image = cv2.cvtColor(image, cv2.COLOR_BGR2GRAY)

# Apply Gaussian Blur to the image
blurred_image = cv2.GaussianBlur(gray_image, (5, 5), 0)

# Save the processed image
cv2.imwrite('processed_image.jpg', blurred_image)

# Display the original and processed images
cv2.imshow('Original Image', image)
cv2.imshow('Processed Image', blurred_image)
cv2.waitKey(0)
cv2.destroyAllWindows()
  `;

  return (
    <body>
      <Helmet>
        <title>AI Image Processing</title>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="keywords" content="AI Image Processing, OpenCV, AI Tutorial" />
        <meta name="description" content="Learn about AI image processing, its applications, and practical examples using OpenCV." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <br />
      <Sidenav />
      <div className="content">
        <header className="headertutorials" style={newCode}>
          <ScrollToTopLink to="/AI_computer_vision"><ButtonPrevious /></ScrollToTopLink>
          <ScrollToTopLink to="/AI_object_detection"><ButtonNext /></ScrollToTopLink>
          <h1>AI Image Processing</h1>
        </header>
        <Navbar />
        <main>
          <section>
            <p>Image processing involves the manipulation of digital images through a digital computer. It is a significant aspect of AI, enabling applications in areas such as image enhancement, noise reduction, and edge detection.</p>

            <h2>Introduction to Image Processing</h2>
            <p>Image processing techniques allow us to perform operations like filtering, transforming, and segmenting images. Popular libraries for image processing include OpenCV and PIL (Python Imaging Library).</p>

            <h2>Example: Basic Image Processing with OpenCV</h2>
            <SyntaxHighlighterComponent code={imageProcessingExample} language="python" />
            <p>In this example, we use OpenCV to perform basic image processing operations, including converting an image to grayscale, applying Gaussian blur, and displaying the processed image.</p>
          </section>
        </main>
        <div className="head">
          <ScrollToTopLink to="/AI_computer_vision"><ButtonPrevious /></ScrollToTopLink>
          <ScrollToTopLink to="/AI_object_detection"><ButtonNext /></ScrollToTopLink>
        </div>
      </div>
      <Footertutorials />
    </body>
  );
}
